module.exports = __webpack_public_path__ + "static/media/julesSecure.ff200dff.png";